import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import React, { useState, useEffect } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// 🧹 Sanitize blocks deeply

const sanitizeRaw = (raw) => {
  if (!raw || !Array.isArray(raw.blocks)) return raw;

  return {
    ...raw,
    blocks: raw.blocks.map(block => {
      const textLength = block.text?.length || 0;

      const inlineStyleRanges = Array.isArray(block.inlineStyleRanges)
        ? block.inlineStyleRanges
            .filter(r =>
              typeof r.offset === "number" &&
              typeof r.length === "number" &&
              r.offset >= 0 &&
              r.length >= 0 &&
              r.offset + r.length <= textLength
            )
            .map(r => ({
              ...r,
              style: (r.style || "")
                .replace(/\\"/g, "")     // remove escaped quotes
                .replace(/\\+/g, "")     // remove stray backslashes
                .trim(),
            }))
        : [];

      const entityRanges = Array.isArray(block.entityRanges)
        ? block.entityRanges.filter(r =>
            typeof r.offset === "number" &&
            typeof r.length === "number" &&
            r.offset >= 0 &&
            r.length >= 0 &&
            r.offset + r.length <= textLength
          )
        : [];

      return {
        key: block.key || Math.random().toString(36).slice(2, 8),
        text: block.text || "",
        type: block.type || "unstyled",
        depth: typeof block.depth === "number" ? block.depth : 0,
        inlineStyleRanges,
        entityRanges,
        data: block.data || {},
      };
    }),
    entityMap: raw.entityMap || {},
  };
};


const EditDescriptionBox = ({ content, onChange }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

 useEffect(() => {
  if (!content) {
    setEditorState(EditorState.createEmpty());
    return;
  }

  try {
    // 🧩 Handle double stringified content (common issue)
    let parsed = content;
    if (typeof content === "string") {
      parsed = JSON.parse(content);
      if (typeof parsed === "string") parsed = JSON.parse(parsed);
    }

    // ✅ Sanitize deeply
    const cleaned = sanitizeRaw(parsed);

    // 🚫 Validate critical fields before passing to convertFromRaw
    if (
      !cleaned ||
      !Array.isArray(cleaned.blocks) ||
      typeof cleaned.entityMap !== "object"
    ) {
      throw new Error("Invalid DraftJS raw structure");
    }

    const contentState = convertFromRaw(cleaned);
    setEditorState(EditorState.createWithContent(contentState));
  } catch (error) {
    console.warn("⚠️ DraftJS failed to load raw data. Falling back to plain text.", error);

    // 🧹 Fallback: try to extract readable text from raw JSON
    try {
      const text =
        typeof content === "string"
          ? JSON.parse(content)?.blocks?.map(b => b.text).join("\n")
          : Array.isArray(content?.blocks)
          ? content.blocks.map(b => b.text).join("\n")
          : String(content || "");

      const contentState = ContentState.createFromText(text);
      setEditorState(EditorState.createWithContent(contentState));
    } catch {
      setEditorState(EditorState.createEmpty());
    }
  }
}, []);


 const handleEditorChange = (state) => {
  setEditorState(state);
  const raw = convertToRaw(state.getCurrentContent());

  // sanitize before sending to backend
  // const cleaned = sanitizeRaw(raw);

  onChange(raw);     // ONLY send pure RAW

};


  console.log(content)

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleEditorChange}
      wrapperClassName="wrapper"
      editorClassName="editor"
      toolbarClassName="toolbar"
    />
  );
};

export default EditDescriptionBox;
